export const getDuplicates = <T>(entities: T[], key: keyof T) => {
  const lookup = entities.reduce((a: any, e: T) => {
    a[e[key as keyof object]] = ++a[e[key as keyof object]] || 0;
    return a;
  }, {} as T);

  return entities.filter((e) => lookup[e[key]]);
};
